import { render, staticRenderFns } from "./ListNotification.vue?vue&type=template&id=49b5f37b&scoped=true&"
import script from "./ListNotification.vue?vue&type=script&lang=js&"
export * from "./ListNotification.vue?vue&type=script&lang=js&"
import style0 from "./ListNotification.vue?vue&type=style&index=0&id=49b5f37b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b5f37b",
  null
  
)

export default component.exports